export default __webpack_public_path__ + "static/media/loh_editors.5dc37409.svg";